export const HOME_PAGE_LOADED = 'HOME_PAGE_LOADED';

export const homePageLoaded = (surveyName = null) => {
  return {
    type: HOME_PAGE_LOADED,
    meta: {
      surveyName
    }
  };
};
